export enum SensorType {
  O365_MAIL = 1,
  O365_AUDIT = 2,
  AD_ONPREM_DOMAIN = 3,
  AWS = 4,
  AZURE_AD_AUDIT = 5,
  NSVA = 6,
  INTUNE = 7,
  AZURE_CW = 8,
  GOOGLE_WS = 9,
  GCP = 10,
  MOBILE_SECURITY = 11,
  CLOUD_SECURITY = 12,
  ATLASSIAN_JIRA = 13,
  ATLASSIAN_CONFLUENCE = 14,
  ATLASSIAN_AUDIT = 15,
  AZURE_AD_EVENT_HUB = 16,
}

export enum SensorEvent {
  change = 'change',
  enableSensor = 'enableSensor',
  init = 'init',
}
